import { Box, Text, Button, useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateTutor } from "../../redux/api_calls/apiCalls";
import LoadingModal from "../common/LoadingModal";
// import { deleteTopic } from "../../redux/api_calls/apiCalls";
import IndividualTutorCard from "./IndividualTutorCard";

export default function AllTutors({ tutors, method, loadMoreVisible }) {
    const dispatch = useDispatch()
    const { isLoading, processFinished, error } = useSelector(state => state.approvalState)
    const toast = useToast()

    const updateHandler = (id, status) => {
        dispatch(updateTutor(id, status, tutors))
    }

    useEffect(() => {
        if (!isLoading) {
            if (!processFinished && error) {
                toast({
                    title: "Error!",
                    description: error,
                    status: "error",
                    duration: 1000,
                    isClosable: true,
                })
            }
        }
        // eslint-disable-next-line
    }, [processFinished, error, isLoading])

    return (
        <Box width={['95%', '95%', '95%', '80%']} flexDirection='column' justifyContent='space-between' alignItems='center' d={['none', 'none', 'none', 'flex']} mb='1.5rem'  >
            <Box d='flex' width='100%' p='1rem'>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='25%'>Name</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='25%' textAlign='center'>Email</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='22.5%' textAlign='center'>Mobile Number</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='22.5%' textAlign='center'>Status</Text>
            </Box>
            {
                tutors.map((tutor) => <IndividualTutorCard
                    image={tutor.avatar}
                    name={`${tutor.first_name} ${tutor.last_name}`}
                    email={tutor.email}
                    id={tutor.id}
                    key={tutor.id}
                    tutorStatus={tutor.status}
                    mobileNumber={tutor.mobile_no}
                    method={updateHandler}
                />)
            }
            {
                loadMoreVisible &&

                <Button
                    color='#00000099'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='700'
                    fontSize={["12px", "14px", "16px", "18px"]}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    boxShadow='0px 3px 16px rgba(0, 0, 0, 0.1)'
                    borderRadius='xl'
                    py={['0.5rem', '0.75rem', '1rem', '1.5rem']}
                    px={['0.75rem', '1rem', '1.5rem', '2rem']}
                    m='2rem'
                    bg='#ffffff'
                    onClick={method}
                >
                    Load More...
                </Button>
            }

            <LoadingModal isOpen = {isLoading} size = 'md'/>
        </Box>
    )
}